import { computed, inject, Service } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '../../../core/services/auth/auth.service';

export interface PerfilCidadao {
  nomeCompleto: string;
  nomeSocial: string;
  genero: string;
  racaCor: string;
  dataNascimento: string;
  rg: string;
  cpf: string;

  enderecoCompleto: string;
  numero: string;
  complemento: string;
  cep: string;
  bairro: string;
  estado: string;
  cidade: string;

  email: string;
  senha: string;
  telefoneResidencial: string;
  telefoneCelular01: string;
  telefoneCelular02: string;
}

/**
 * Cadastro de exemplo. A leitura real já existe (`MeusDadosService`, `GET sai/core/MeusDados`),
 * mas ainda não foi ligada aqui.
 */
const CADASTRO_BASE: PerfilCidadao = {
  nomeCompleto: 'Rosana Alves',
  nomeSocial: '',
  genero: 'Feminino',
  racaCor: 'Parda',
  dataNascimento: '1988-03-12',
  rg: '1234567 SSP/BA',
  // CPF ficticio, mas com digito verificador valido: desde o CDS-42 o formulario da Ouvidoria
  // confere o documento, e um mock invalido abria a etapa ja com uma pendencia que o cidadao
  // nao criou.
  cpf: '529.982.247-25',
  enderecoCompleto: 'Av. das Flores',
  numero: '158',
  complemento: 'Apto 302',
  cep: '55482-558',
  bairro: 'Comércio',
  estado: 'BA',
  cidade: 'Salvador',
  email: 'rosana.alves@exemplo.com',
  senha: 'senha-cadastrada',
  telefoneResidencial: '(71) 3202-4000',
  telefoneCelular01: '(71) 99999-0001',
  telefoneCelular02: '',
};

/**
 * Cadastro do cidadão usado para preencher formulários de quem já está autenticado.
 *
 * ⚠️ Continua sendo o cadastro de EXEMPLO para Ouvidoria, SIC e a etapa de solicitação de
 * serviço, por decisão da usuária (30/09/2026), até uma change própria. A aba "Dados pessoais"
 * já lê o cadastro real, pelo `MeusDadosService`.
 */
@Service()
export class PerfilCidadaoService {
  private readonly auth = inject(AuthService);

  private readonly usuario = toSignal(this.auth.currentUser, {
    initialValue: this.auth.currentUserValue,
  });

  /** Nome e e-mail vêm do token quando existem; o restante ainda sai do cadastro base. */
  readonly cadastro = computed<PerfilCidadao>(() => {
    const usuario = this.usuario();

    return {
      ...CADASTRO_BASE,
      nomeCompleto: usuario?.nome?.trim() || CADASTRO_BASE.nomeCompleto,
      email: usuario?.email?.trim() || CADASTRO_BASE.email,
    };
  });
}
